module.exports = __webpack_public_path__ + "static/media/e_commercegif.c26431ef.gif";